import Search from './search.js'
import Navigation from './navigation.js'
import Analytics from './analytics.js'
import Consent from './consent.js'

import '../css/main.css'

// Initialize main components
const search = new Search()
const navigation = new Navigation()
const analytics = new Analytics()
// Expose for testing utilities (e.g., enabling GA4 DebugView)
window.analytics = analytics
const consent = new Consent()

// Set up navigation
navigation.bind()

document.addEventListener('DOMContentLoaded', function () {
  // Initialize search functionality
  search.bind()
  search.init()
  
  // Initialize consent and analytics
  consent.init()
  analytics.init()
  
  // Note: Event tracking (search, links, forms) is now handled by the analytics.js module
  // which loads trackingEvents.js and sets up all event listeners properly
  // This prevents duplicate event handlers
})

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').then(registration => {
      console.log('SW registered: ', registration)
    }).catch(registrationError => {
      console.log('SW registration failed: ', registrationError)
    })
  })
}
